import {
  handleGetRequest,
  handlePostRequest,
  handleDeleteRequest,
} from "../hooks/api";

export async function getPostings(requestBody) {
  const endpoint = "/posting/getAllPostings";
  const response = await handlePostRequest(
    endpoint,
    requestBody,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
export async function getPostingById(Id) {
  const endpoint = `/posting/getPosting/${Id}`;
  const response = await handleGetRequest(endpoint, undefined);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function deletePostings(payload) {
  const endpoint = "/posting/deletePosting/" + payload.postingid;
  const response = await handlePostRequest(endpoint, {}, undefined, false);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function getScoops() {
  const endpoint = "/scoop/getAllScoops";
  const response = await handlePostRequest(endpoint, {}, {}, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
export async function getHoops() {
  const endpoint = "/scoop/getAllHoops";
  const response = await handlePostRequest(endpoint, {}, {}, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
export async function getfilterPostings(payload) {
  const endpoint = "/posting/filterPostings";
  const response = await handlePostRequest(endpoint, payload, {}, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
export async function postScoops(payload) {
  const endpoint = "/posting/addPosting";
  const response = await handlePostRequest(endpoint, payload, undefined, true);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function addLike(payload) {
  const endpoint = "/posting/addLikeInPosting";
  const response = await handlePostRequest(endpoint, payload, undefined, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function removeLike(payload) {
  const endpoint = "/posting/removeLikeFromPosting";
  const response = await handlePostRequest(endpoint, payload, undefined, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function getLikesForPost(postId) {
  const endpoint = `/posting/getLikes/${postId}`;
  const response = await handleGetRequest(endpoint, {});

  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export async function addReactionOnComment(payload) {
  const commentId = payload.commentId;

  const body = {
    emojiId: payload.emojiId,
  };

  const endpoint = `/posting/comment/reactions/${commentId}`;
  const response = await handlePostRequest(endpoint, body, undefined, false);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function getReactionOnComment(commentId) {
  const endpoint = `/posting/comment/reaction/${commentId}`;

  const response = await handleGetRequest(endpoint, undefined);

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function deleteReactionOnComment(payload) {
  console.log(payload, "payload");
  const { commentId, ...body } = payload;
  const endpoint = `/posting/comment/reactions/${commentId}`;
  const response = await handleDeleteRequest(endpoint, body);
  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
